import { Button } from "@simplicity/ui";
import { ChevronDown, ChevronUp } from "lucide-react";

// Collapsible section header used across UserManagement sections.

export function SectionHeader({
  collapsed,
  onToggle,
  icon,
  title,
  actions,
}: {
  collapsed: boolean;
  onToggle: () => void;
  icon: React.ReactNode;
  title: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between mb-4">
      <Button
        variant="ghost"
        className="flex items-center gap-2 text-lg font-semibold p-0 h-auto hover:bg-transparent hover:text-foreground/80"
        onClick={onToggle}
      >
        {collapsed ? (
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        ) : (
          <ChevronUp className="h-4 w-4 text-muted-foreground" />
        )}
        {icon} {title}
      </Button>
      {!collapsed && actions}
    </div>
  );
}
